import { VIEWED_CONTACT_INFO } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackViewContactInformation = async (context) =>
  trackBaseEvent(context, {
    eventName: VIEWED_CONTACT_INFO,
    properties: {},
  });
